/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ZapierSubscriptionCreate = {
  target_url: string;
  event_type: ZapierSubscriptionCreate.event_type;
};
export namespace ZapierSubscriptionCreate {
  export enum event_type {
    COMPANYMEASUREMENTDATE_CREATED = 'companymeasurementdate.created',
  }
}
